<template>
  <div>
    <el-table
        v-loading="loading" :max-height="height" :height="height != null ? height : null"
        :data="data" style="width: 100%" header-row-class-name="tableHead"
        ref="theTable"
        @row-click="rowsClick"
        :tree-props="treeprops"
        highlight-current-row
        @row-dblclick="rowdblclick"
        @current-change="nowCurrentChange"
        @selection-change="selectionChange"
        :default-expand-all="defaultexpandall"
        :row-key="rowKey"
        :cell-style="{borderColor:''}"
        :cell-class-name="cellClassName"
        stripe="true"
        :header-cell-style="{ background: '#F1F6FF', color: '#333' }" border>
      <!-- <el-table-column label="序号" fixed="left" type="index" width="75" align="center" /> -->
      <slot></slot>
    </el-table>
    <!-- 分页组件 -->
  </div>
  <div>
    <pagination
        v-if="total > 0" :total="total"
        :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
        @pagination="pagination"/>
  </div>
</template>

<script>
export default {
  name: "yzTable",

  props: [
    'loading',
    'data',
    'total',
    'queryParams',
    'height',
    'rowClick',
    'currentChange',
    'treeprops',
    'defaultexpandall',
    "rowKey",
    "cellClassName"
  ],
  data() {
    return {}
  },
  methods: {
    toggleRowSelection(row,val){
      this.$refs.theTable.toggleRowSelection(row,val)
    },
    toggleAllSelection(){
      this.$refs.theTable.toggleAllSelection()
    },
    nowCurrentChange(val) {
      this.$emit('currentChange', val)
    },
    selectionChange(val) {
      this.$emit('selectionChange', val)
    },
    pagination(val) {
      this.$emit('getList', val)
    },
    rowdblclick(row) {
      this.$emit('rowdblclick', row)
    },
    rowsClick(row) {
      this.$emit('rowClick', row)
    }
  },
  emits: ['currentChange', 'getList', 'rowdblclick', 'selectionChange','rowClick'],
}
</script>

<style lang="less">

// .tableHead {
//   --el-table-header-bg-color: #3C8DBC;

//   th.el-table__cell {
//     background-color:   !important;

//     .cell {
//       font-size: 14px;
//       font-family: Source Han Sans CN-Regular, Source Han Sans CN;
//       font-weight: 400;
//       color: #FFFFFF;
//       line-height: 22px;

//     }

//     .el-table-fixed-column--left {
//       background-color: #004682;
//     }
//   }
// }

.el-table {

  // border-left: 1px solid #97b4c4;
}

</style>
